import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { PageHeader } from '@/components/dashboard/page-header';
import { ProjectCalendarClient } from '@/components/project/project-calendar-client';

export const Route = createFileRoute('/_app/projects/$id/calendar')({
  component: ProjectCalendarPage,
});

function ProjectCalendarPage(): React.ReactElement {
  const { id } = Route.useParams();
  const t = useTranslations('project.calendar');
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t('pageTitle')} subtitle={t('pageSubtitle')} />
      <ProjectCalendarClient projectId={id} />
    </div>
  );
}
